export function TableIcon() {
  return (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <path d="M25,10 C16.7,10 10,16.7 10,25 L10,75 C10,83.3 16.7,90 25,90 L75,90 C83.3,90 90,83.3 90,75 L90,25 C90,16.7 83.3,10 75,10 L25,10 Z M31,18 L31,33 L18,33 L18,25 C18,21.1 21.1,18 25,18 L31,18 Z M39,18 L75,18 C78.9,18 82,21.1 82,25 L82,33 L39,33 L39,18 Z M18,41 L31,41 L31,59 L18,59 L18,41 Z M39,41 L82,41 L82,59 L39,59 L39,41 Z M18,67 L31,67 L31,82 L25,82 C21.1,82 18,78.9 18,75 L18,67 Z M39,67 L82,67 L82,75 C82,78.9 78.9,82 75,82 L39,82 L39,67 Z" fill="currentColor" />
    </svg>
  );
}
